import { render, staticRenderFns } from "./collectionForm.vue?vue&type=template&id=e7f03788"
import script from "./collectionForm.vue?vue&type=script&lang=js"
export * from "./collectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports